import { NewsItemType } from '../../config/types'
import * as types from '../actions/types'
import createReducer from '../createReducer'

type NewsTypes = {
  list: Array<NewsItemType>
  articles: unknown | null
}

const initialState: NewsTypes = {
  list: [],
  articles: null,
}

export const news = createReducer(initialState, {
  [types.GET_NEWS_LIST](state, action) {
    const newState = { ...state, list: action.news }
    return newState
  },
  [types.GET_NEWS_ARTICLE](state, action) {
    const newsArticles = { ...state.articles }
    newsArticles[action.newsId] = {
      ...action.newsArticle[0],
      nid: action.newsId,
    }

    const newState = { ...state, articles: newsArticles }
    return newState
  },
})
